import { render } from "./Tuzilma.vue?vue&type=template&id=1ac55635&scoped=true"
import script from "./Tuzilma.vue?vue&type=script&lang=js"
export * from "./Tuzilma.vue?vue&type=script&lang=js"

import "./Tuzilma.vue?vue&type=style&index=0&id=1ac55635&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac55635"]])

export default __exports__